import gql from 'graphql-tag';

const guaranteeExtensionEligibilityQuery = gql`
  query guaranteeExtensionEligibility($guaranteePurchaseId: ID!) {
    extensionEligibility(guaranteePurchaseId: $guaranteePurchaseId) {
      allowed
      reason
    }
  }
`;

export default guaranteeExtensionEligibilityQuery;
